import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(planner-screens)/planner/")({
  beforeLoad: () => {
    throw redirect({
      to: "/planner/list",
      search: {
        filters: undefined,
        sorts: undefined,
        search: undefined,
      },
    });
  },
});
